export function isAutofillChange(target: EventTarget | null): boolean {
  return !!target && document.activeElement !== target;
}
